<script setup>
import { OnClickOutside } from '@vueuse/components';
import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  icon: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  menuItems: {
    type: Array,
    default: () => [],
  },
  showSearch: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle', 'close', 'action']);
</script>

<template>
  <OnClickOutside class="relative shrink-0" @trigger="emit('close')">
    <Button
      variant="outline"
      size="sm"
      :icon="icon"
      :color="isActive ? 'blue' : 'slate'"
      class="max-w-48 !h-8 !px-2.5"
      :class="isActive ? 'text-n-slate-12' : 'text-n-slate-11'"
      @click="emit('toggle')"
    >
      <span class="truncate">{{ label }}</span>
      <Icon
        icon="i-lucide-chevron-down"
        class="shrink-0"
        :class="isActive ? '' : 'text-n-slate-11'"
      />
    </Button>
    <DropdownMenu
      v-if="isOpen"
      :menu-items="menuItems"
      :show-search="showSearch"
      class="mt-1 end-0 top-full w-56 max-h-80"
      @action="emit('action', $event)"
    />
  </OnClickOutside>
</template>
